import type {
  MarketingSegmentDefinition,
  MarketingSegmentRule,
} from '../../../lib/api';

export type MarketingSegmentRuleField = MarketingSegmentRule['field'];

export function createMarketingSegmentRule(
  field: MarketingSegmentRuleField,
  now = new Date(),
): MarketingSegmentRule {
  switch (field) {
    case 'EMAIL':
      return { field, operator: 'IS_SET' };
    case 'EMAIL_CONSENT':
      return { field, operator: 'IS', value: 'GRANTED' };
    case 'EMAIL_PREFERENCE':
      return { field, operator: 'IS', value: 'ENABLED' };
    case 'ACQUISITION_TYPE':
      return { field, operator: 'IS', value: 'ORDER' };
    case 'CONTACT_DATE': {
      const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1_000);
      return {
        field,
        dateField: 'LAST_SEEN_AT',
        operator: 'AFTER',
        value: thirtyDaysAgo.toISOString(),
      };
    }
    case 'PURCHASE_HISTORY':
      return { field, operator: 'HAS_PAID_ORDER' };
  }
}

export function createDefaultMarketingSegmentDefinition(): MarketingSegmentDefinition {
  return {
    schemaVersion: 1,
    operator: 'ALL',
    rules: [createMarketingSegmentRule('EMAIL')],
  };
}

export function replaceMarketingSegmentRuleField(
  definition: MarketingSegmentDefinition,
  ruleIndex: number,
  field: MarketingSegmentRuleField,
  now = new Date(),
): MarketingSegmentDefinition {
  return {
    ...definition,
    rules: definition.rules.map((rule, index) => (
      index === ruleIndex ? createMarketingSegmentRule(field, now) : rule
    )),
  };
}

export function dateTimeLocalValue(isoValue: string): string {
  const date = new Date(isoValue);
  if (Number.isNaN(date.getTime())) return '';
  const offsetMs = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offsetMs).toISOString().slice(0, 16);
}

export function dateTimeLocalToIso(value: string): string | null {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}
